import React from "react";
import Logo from "../../Components/CompanyLogo";
import NavAuthState from "./NavAuthState";
import NavCart from "./NavCart";
import SearchBox from "./SearchBox";

const CenterNav = () => {
  return (
    <div className="border-b pt-10">
      <nav className="flex justify-between md:px-3 pb-4 pt-2 items-center bg-white max-w-7xl border-slate-300 mx-auto">
        <h1 className="text-xl text-gray-800 font-bold hidden md:block">
          <Logo />
        </h1>

        <div className="flex items-center w-full md:w-[68%]">
          <SearchBox />
        </div>
        <div className=" hidden md:flex items-center ">
          <ul className="flex items-center space-x-10">
            <li>
              <NavAuthState />
            </li>
            <li>
              <NavCart />
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default CenterNav;
